module.exports = __webpack_public_path__ + "img/new_index_cases23.cac73544.png";